import { z } from 'zod';

export const PhotosPartialSchema = z.object({
    photos: z.array(
        z.strictObject({
            id: z.string(),
            src: z.string(),
        }),
    ),
});

export const PhotosSchema = PhotosPartialSchema.extend({
    photos: z
        .array(
            z.strictObject({
                id: z.string(),
                src: z.string(),
            }),
        )
        .min(5, { message: 'At least 5 photos are required' }),
});
